
/* injects from baggage-loader */

'use strict';

/**
 * Constants to use in the application depending of the environment used.
 *
 * @export
 * @param {shared.module} app
 */
export default function (app) {

	/**
	 * Constants definition for the navigation routes for each profiles in the applications.
	 */
	const navigationConstant = {
		RESOURCES: [
			// Campaign management. index = 0.
			{
				CODE: '01',
				ICON: 'fa fa-calendar-o',
				NAME: 'Campaña',
				STATE: 'campaign',
				URL: '/administrar-campanas'
			},
			// Reports generation. index = 1.
			{
				CODE: '02',
				ICON: 'fa fa-file-text-o',
				NAME: 'Informes',
				STATE: 'report',
				URL: '/generar-informes'
			},
			// Authentication. index = 2.
			{
				CODE: '03',
				ICON: 'fa',
				NAME: 'Autenticación',
				STATE: 'authentication',
				URL: '/autenticacion'
			},
			// Not found. index = 3.
			{
				CODE: '04',
				ICON: 'fa',
				NAME: 'Oops',
				STATE: 'notFound',
				URL: '/oops'
			},
			// File management. index = 4.
			{
				CODE: '05',
				ICON: 'fa',
				NAME: 'Gestión de archivos',
				STATE: 'fileManagement',
				URL: '/gestinar-archivos'
			},
			// User management. index = 5.
			{
				CODE: '06',
				ICON: 'fa',
				NAME: 'Gestionar Usuarios',
				STATE: 'user',
				URL: '/gestionar-usuarios'
			},
			// View Components. index = 6.
			{
				CODE: '07',
				ICON: 'fa fa-ticket',
				NAME: 'Componentes',
				STATE: '',
				SUBMENUS: [
					// confirmed components. sub-index = 0.
					{
						CODE: '0702',
						NAME: 'Mis componentes ',
						STATE: 'confirmed',
						URL: '/componentes-confirmados',
					},
					// assign components. sub-index = 1.
					{
						CODE: '0703',
						NAME: 'Asignar componentes',
						STATE: 'assignment',
						URL: '/asignar-componentes'
					},
					// return components. sub-index = 2.
					{
						CODE: '0704',
						NAME: 'Registrar devolución de componentes',
						STATE: 'returnComponent',
						URL: '/registrar-devolucion-componentes'
					},
					// confirm components. sub-index = 3.
					{
						CODE: '0705',
						NAME: 'Confirmar componentes',
						STATE: 'pendingToConfirm',
						URL: '/confirmar-componentes'
					},
					// lock components. sub-index = 4.
					{
						CODE: '0706',
						NAME: 'Bloquear componentes',
						STATE: 'lockComponent',
						URL: '/bloquear-componentes'
					},
					// unlock components. sub-index = 5.
					{
						CODE: '0707',
						NAME: 'Desbloquear componentes',
						STATE: 'unlockComponent',
						URL: '/desbloquear-componentes'
					},
					// return component to company. sub-index = 6.
					{
						CODE: '0708',
						NAME: 'Devolver componentes a empresa',
						STATE: 'companyToReturn',
						URL: '/devolver-componentes-a-empresa'
					},
					// confirm component to office. sub-index = 7.
					{
						CODE: '0709',
						NAME: 'Confirmar componentes de Oficina',
						STATE: 'pendingToConfirmOffice',
						URL: '/confirmar-componentes-a-oficina'
					},
								// confirm component to company. sub-index = 8.
					{
						CODE: '0710',
						NAME: 'Confirmar devolución a empresa',
						STATE: 'pendingToConfirmCompany',
						URL: '/confirmar-devolucion-a-empresa'
					}
				],
				URL: ''
			},
		]
	};

	app.constant('navigationConstant', navigationConstant);
}



// WEBPACK FOOTER //
// ./src/app/core/constants/navigation.constants.js